/* eslint-disable no-unused-vars */
import React from 'react'
import * as S from '../styles'

const TabItem = ({ label, name, value, onChange, onClick, checked }) => {
  return (
    <S.ChoosePayment onClick={onClick}>
      <S.ChoosePaymentItem
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        readOnly={!onChange}
      />
      <label>{label}</label>
    </S.ChoosePayment>
  )
}

export default TabItem
